import React, { lazy } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ContactForm } from '../components/ContactForm';
import { ContactInfo } from '../components/ContactInfo';
import { motion } from 'framer-motion';
export function ContactPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-963">
      <Navbar data-id="element-964" />

      {/* Banner Section */}
      <div className="relative h-[40vh] min-h-[350px] flex items-center justify-center overflow-hidden" data-id="element-965">
        <div className="absolute inset-0 z-0" data-id="element-966">
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60 z-10" data-id="element-967" />
          <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070&auto=format&fit=crop" alt="Contact Us Banner" className="w-full h-full object-cover" data-id="element-968" />
        </div>

        <div className="relative z-20 text-center px-4 max-w-4xl mx-auto mt-16" data-id="element-969">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-5xl md:text-6xl font-bold text-white mb-4" data-id="element-970">
            Contact Us
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-xl text-gray-200 max-w-2xl mx-auto" data-id="element-971">
            Have questions about your next adventure? We're here to help you
            plan the perfect Himalayan trek. Get in touch with our expert team
            today.
          </motion.p>
        </div>
      </div>

      {/* Main Contact Section */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-972">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-973">
          {/* Left Panel - Company Details */}
          <div data-id="element-974">
            <ContactInfo data-id="element-975" />
          </div>

          {/* Right Panel - Contact Form */}
          <div data-id="element-976">
            <ContactForm data-id="element-977" />
          </div>
        </div>
      </main>

      {/* Google Map Section */}
      <section className="w-full bg-white py-16" data-id="element-978">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-979">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-8" data-id="element-980">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-981">
              Visit Our Office
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-982">
              Our head office is located in the heart of Thamel, Kathmandu's
              tourist hub. Drop by for a coffee and let's plan your adventure
              together.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full h-[500px] rounded-2xl overflow-hidden shadow-xl border border-gray-200" data-id="element-983">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.0234567890123!2d85.31234567890123!3d27.71234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjfCsDQyJzQ0LjQiTiA4NcKwMTgnNDQuNCJF!5e0!3m2!1sen!2snp!4v1234567890123!5m2!1sen!2snp" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Himalayan Trekking Office Location - Thamel, Kathmandu" data-id="element-984" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mt-6 text-center" data-id="element-985">
            <p className="text-gray-600" data-id="element-986">
              <span className="font-semibold text-gray-900" data-id="element-987">Address:</span>{' '}
              Thamel Marg, Kathmandu 44600, Nepal
            </p>
            <p className="text-sm text-gray-500 mt-1" data-id="element-988">
              (Opposite to Garden of Dreams)
            </p>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-989" />
    </div>;
}